export default "__VITE_ASSET__DCUpEdWS__"